export const transactionsData = [
	{
		id: 30911,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 149000,
		created_at: '2022-10-04T11:16:03+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30908', reason: 'Reject by user' },
	},
	{
		id: 30910,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T07:51:35+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30909', reason: 'Reject by user' },
	},
	{
		id: 30909,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 147000,
		created_at: '2022-10-04T07:51:33+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30908,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T07:40:27+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30907,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 149000,
		created_at: '2022-10-04T07:35:33+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30904', reason: 'Rejected due to bank account is inactivated by user' },
	},
	{
		id: 30904,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T05:46:19+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30903,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 149000,
		created_at: '2022-10-04T05:38:29+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30902', reason: 'Rejected due to bank account is inactivated by user' },
	},
	{
		id: 30902,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T05:36:21+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30900,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 149000,
		created_at: '2022-10-04T04:13:09+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30898', reason: 'Rejected due to bank account is inactivated by user' },
	},
	{
		id: 30899,
		type: { id: 2, name: 'Credit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T04:13:09+00:00',
		client_transaction_id: null,
		meta: { reversed_transaction: '#30897', reason: 'Rejected due to bank account is inactivated by user' },
	},
	{
		id: 30898,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 147000,
		created_at: '2022-10-04T03:43:44+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30897,
		type: { id: 1, name: 'Debit' },
		category: { id: 2, name: 'Withdraw' },
		amount: 1000,
		balance: 148000,
		created_at: '2022-10-04T03:41:53+00:00',
		client_transaction_id: null,
		meta: { bank_account: '015010 XXXX1111' },
	},
	{
		id: 30676,
		type: { id: 1, name: 'Debit' },
		category: { id: 3, name: 'Bet' },
		amount: 1000,
		balance: 149000,
		created_at: '2022-09-05T00:41:45+00:00',
		client_transaction_id: 'br:c:229',
		meta: {
			bet_ticket: '#1-26530',
			type: 'Racing',
			events: 'Warrnambool (2022-09-05) Race 1',
			selections: 'Fixed Price Win: 1. Moraine Zorro',
			bet: '$10',
			odds: '2.48',
		},
	},
	{
		id: 30675,
		type: { id: 2, name: 'Credit' },
		category: { id: 5, name: 'Adjustment' },
		amount: 150000,
		balance: 150000,
		created_at: '2022-09-05T00:40:18+00:00',
		client_transaction_id: null,
		meta: { category: 'Betback Result Correction' },
	},
];

export enum BrandNames {
	PlayUp = 'PlayUp',
	Booki = 'Booki',
	Fantasy = 'Fantasy',
	Prosper = 'Propsper',
}
